export default __webpack_public_path__ + "static/media/makeAnImpact Mobile Pic.2245b2bd.png";